/* eslint-disable */
import $ from 'jquery';
import 'jquery-mask-plugin';
import Swiper from 'swiper/swiper-bundle.js';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

window.$ = $;
window.jQuery = $;

$(() => {
    Fancybox.bind("[data-fancybox]", {});
})

// phones
$(() => {
    $('[name="phone"]').mask('+7 (000) 000 00 00');
});

// // scroll menu
// $(() => {
//     $(window).on('scroll', function () {
//         if ($(this).scrollTop() > 130) {
//             $('.header').addClass('scrolled');
//             setTimeout(() => {
//                 $('.header').addClass('animated');
//             }, 300);
//         } else {
//             $('.header').removeClass('scrolled');
//             $('.header').removeClass('animated');
//         }
//     });
// });

// hero
$(() => {
    new Swiper('.hero__slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        autoplay: {
            delay: 4500
        },
        navigation: {
            nextEl: '.hero__slider .next',
            prevEl: '.hero__slider .prev',
        },
        pagination: {
            el: ".hero__slider .hero__pagination",
        },
        breakpoints: {}
    });
});

// tabs
$(() => {
    const $tabsContainer = $('.what-do__tabs');
    const $tabButtons = $tabsContainer.find('button');
    const intervalTime = 4500;
    let autoSwitchInterval;
    let currentIndex = 0;

    function showTab(index) {
        $tabButtons.removeClass('active');
        $tabButtons.eq(index).addClass('active');

        const tabId = $tabButtons.eq(index).data('tab');
        $('.what-do__content').hide();
        $(`.what-do__content[data-content="${tabId}"]`).css('display', 'grid');
    }

    function startAutoSwitch() {
        autoSwitchInterval = setInterval(() => {
            currentIndex = (currentIndex + 1) % $tabButtons.length;
            showTab(currentIndex);
        }, intervalTime);
    }

    startAutoSwitch();

    $tabButtons.on('click', function() {
        clearInterval(autoSwitchInterval);

        const clickedIndex = $tabButtons.index(this);
        currentIndex = clickedIndex;
        showTab(currentIndex);
    });
});

// cases
$(() => {
    const slider = new Swiper('.cases__swiper .swiper', {
        loop: true,
        slidesPerView: 3.7,
        spaceBetween: 20,
        init: false,
        grabCursor: true,
        navigation: {
            nextEl: '.cases__slider .next',
            prevEl: '.cases__slider .prev',
        },
        breakpoints: {
            2000: {
                slidesPerView: 4.7,
            },
            1024: {
                slidesPerView: 3.7,
            },
            320: {
                slidesPerView: 1.4
            }
        }
    });

    // slider.on('slideChangeTransitionStart', function () {
    //     console.log('slideChangeTransitionStart');
    // });
    // slider.on('slideChangeTransitionEnd', function () {
    //     console.log('slideChangeTransitionEnd');
    // });
    slider.on('sliderFirstMove', function () {
        $('.cases__swiper .corner').css('opacity', 0);
    });
    slider.on('transitionStart', function () {
        $('.cases__swiper .corner').css('opacity', 0);
    });
    slider.on('transitionEnd', function () {
        $('.cases__swiper .corner').css('opacity', 1);
    });
    slider.on('afterInit', function () {
        const text = $(this.slides[this.activeIndex]).find('.slide__fulltext').html();
        $('.cases .cases__text').html(text);
    });
    slider.on('slideChange', function () {
        const text = $(this.slides[this.activeIndex]).find('.slide__fulltext').html();
        $('.cases .cases__text').html(text);
    });
    
    slider.init();

    const defaultMarginLeft = $('.cases .container:first-child').css('marginLeft');
    $('.cases__slider').css('marginLeft', defaultMarginLeft);
    $(window).on('resize', function() {
        const marginLeft = $('.cases .container:first-child').css('marginLeft');
        $('.cases__slider').css('marginLeft', marginLeft);
    });

    setTimeout(() => {
        const defaultLeftCorner = $('.cases .cases__slide.slide').css('width');
        $('.cases__swiper .corner.right').css('left', `calc(${defaultLeftCorner} + 10px)`);
    }, 100);
    $(window).on('resize', function() {
        const leftCorner = $('.cases .cases__slide.slide').css('width');
        $('.cases__swiper .corner.right').css('left', `calc(${leftCorner} + 10px)`);
    });

});

// insights
$(() => {
    new Swiper('.insights__slider .swiper', {
        loop: true,
        slidesPerView: 3.995,
        spaceBetween: 0,
        grabCursor: true,
        navigation: {
            nextEl: '.insights .next',
            prevEl: '.insights .prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 3.995,
            },
            320: {
                slidesPerView: 1.4
            }
        }
    });
});

// team
$(() => {
    new Swiper('.team__slider', {
        loop: true,
        slidesPerView: 5.7,
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
            el: ".team.modal .swiper-pagination",
            type: "progressbar",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.8,
            },
            1024: {
                slidesPerView: 5.7,
            }
        }
    });

    $('.who-we__discover .discover__photos img').on('click', function() {
        if (!window.matchMedia('(max-width: 991px)').matches) return;

        const child = $(this);
        const parent = $(this).parents('.discover__photos');

        // Получаем координаты относительно страницы
        const childOffset = child.offset();
        const parentOffset = parent.offset();

        // Учитываем прокрутку родителя
        const parentScrollTop = parent.scrollTop();
        const parentScrollLeft = parent.scrollLeft();

        // Вычисляем позицию ребёнка внутри родителя, с учётом прокрутки
        const positionInParent = {
            top: childOffset.top - parentOffset.top + parentScrollTop,
            left: childOffset.left - parentOffset.left + parentScrollLeft
        };

        $('.who-we__people').removeClass('active');
        $(`.who-we__people[data-id="${$(this).data('id')}"]`).addClass('active');
        $('.who-we__discover .discover__photos img').removeClass('active');
        $(this).addClass('active');
        $('.discover__corners').css('left', `${positionInParent.left - 3}px`);
    });
});

// // gallery
// $(() => {
//     Fancybox.bind("[data-fancybox]", {
//         Images: {
//             initialSize: "fit",
//         },
//     });
// });

// modals
$(() => {
    $('[data-modal]').on('click', function (e) {
        e.preventDefault();

        const modalID = $(this).data('modal');

        if (modalID === 'modal-people') {
            const data = JSON.parse($(this).find('script').text());

            $(`#${modalID} .people__photo`).attr('src', data.image);
            $(`#${modalID} .people__name`).text(data.name);
            $(`#${modalID} .people__position`).text(data.position);
            $(`#${modalID} .people__text`).html(data.text);
        }

        $(`#${modalID}`).addClass('visible');
        // $('html').addClass('no-scroll');
    });

    $('.modal__close').on('click', function () {
        $(this).parents('.modal').removeClass('visible');
        $('html').removeClass('no-scroll');
    });

    $('.modal').on('click', function (e) {
        if ($(e.target).hasClass('modal') && $(e.target).hasClass('visible')) {
            $(e.target).removeClass('visible');
            // $('html').removeClass('no-scroll');
        }
    });
});

// anims
$(() => {
    // if (window.matchMedia('(max-width: 991px)').matches) return;
    AOS.init({
        disable: () => window.matchMedia('(max-width: 991px)').matches,
        once: true,
        offset: 150
    });
});

// scroll to
$(() => {
    $('[data-scroll]').on('click', function (e) {
        e.preventDefault();

        const block = $($(this).attr('href'));

        if (!$(block).length) return;

        if ($('.mobile-dropdown').hasClass('open')) {
            $('.header__burger, .mobile-dropdown').toggleClass('open');
            $('html').removeClass('no-scroll');
        }

        $('html, body').stop().animate({
            scrollTop: block.offset().top - 80
        }, 1000);

        return;
    });
});

// mobile menu
$(() => {
    $('.header__burger').on('click', function () {
        $('.header__burger, .mobile-dropdown').toggleClass('open');
        $('html').toggleClass('no-scroll');
    });
});